import React from 'react';
import { ChallengeDescriptor, ChallengeListItem } from '../../../types/Challenge';
import './BrowseChallengesInSplitPanel.scss';
import BrowseChallenges from './BrowseChallenges';
import { PropertyFilterToken } from '@amzn/awsui-collection-hooks';

interface BrowseChallengesInSplitPanelProps {
  toggleChallengeInfo: (challengeItem: ChallengeListItem) => void;
  currentChallengeDescriptors: ChallengeDescriptor[];
  handleChallengeAction: (challenges: ChallengeDescriptor[]) => void;
  excludedChallenges?: ChallengeDescriptor[];
  defaultQueryTokens?: PropertyFilterToken[];
  /** If true, only show challenges with lcsrTicket. Only jam-admins can remove this filter. */
  requireLcsrTicket?: boolean;
}

const BrowseChallengesInSplitPanel: React.FC<BrowseChallengesInSplitPanelProps> = ({
  toggleChallengeInfo,
  currentChallengeDescriptors,
  handleChallengeAction,
  excludedChallenges = [],
  defaultQueryTokens = [],
  requireLcsrTicket = false,
}) => {
  return (
    <div className="browse-challenges">
      <BrowseChallenges
        showSelectedSplitPanel={false}
        toggleChallengeInfo={toggleChallengeInfo}
        currentChallengeDescriptors={currentChallengeDescriptors}
        handleChallengeAction={handleChallengeAction}
        excludedChallenges={excludedChallenges}
        defaultQueryTokens={defaultQueryTokens}
        requireLcsrTicket={requireLcsrTicket}
        editMode
      />
    </div>
  );
};
export default BrowseChallengesInSplitPanel;
